import React, { useMemo } from 'react';
import MenuCarouselList from '@/components/menus/MenuCarouselList';
import { MENU_FEATURE_COOKING_POPULUR, MENU_FEATURE_NONE_COOKING_POPULUR } from '@/constants/app';
import useMenuList from '@/hooks/useMenuList';

const MenuIndexListContainer = () => {
  const menuList = useMenuList();

  const contents = useMemo(
    () => [
      {
        title: MENU_FEATURE_COOKING_POPULUR,
        list: menuList.filter((item) => item.fields.feature?.includes(MENU_FEATURE_COOKING_POPULUR))
      },
      {
        title: MENU_FEATURE_NONE_COOKING_POPULUR,
        list: menuList.filter((item) =>
          item.fields.feature?.includes(MENU_FEATURE_NONE_COOKING_POPULUR)
        )
      }
    ],
    [menuList]
  );
  return (
    <>
      {contents.map((item) => {
        return <MenuCarouselList title={item.title} menuList={item.list} key={item.title} />;
      })}
    </>
  );
};

export default MenuIndexListContainer;
